export const potencyCodeMap: Record<string, { singular: string; plural: string }> = {
    // C48521: { singular: 'Packet', plural: 'Packets' },
    // C48520: { singular: 'Package', plural: 'Packages' },
    // C48481: { singular: 'Cartridge', plural: 'Cartridges' },
    // C65060: { singular: 'Puff', plural: 'Puffs' },
    // C47916: { singular: 'Kit', plural: 'Kits' },
    // C64696: { singular: 'Caplet', plural: 'Caplets' },
    // C62276: { singular: 'Insert', plural: 'Inserts' },
    // C122629: { singular: 'Actuation', plural: 'Actuations' },
    // C48525: { singular: 'Pellet', plural: 'Pellets' },
    // C48524: { singular: 'Patch', plural: 'Patches' },
    // C48529: { singular: 'Pint', plural: 'Pints' },
    // C64933: { singular: 'Each', plural: 'Each' },
    // C48494: { singular: 'Fluid Ounce', plural: 'Fluid Ounces' },
    // C48534: { singular: 'Quart', plural: 'Quarts' },
    // C25397: { singular: 'Application', plural: 'Applications' },
    // C48499: { singular: 'Implant', plural: 'Implants' },
    // C186222: { singular: 'Chewable gel (Gummy)', plural: 'Chewable gels (Gummies)' },
    // C48491: { singular: 'Metric Drop', plural: 'Metric Drops' },
    // C48490: { singular: 'Disk', plural: 'Disks' },
    // C67315: { singular: 'MilliUnit', plural: 'MilliUnits' },
    // C42915: { singular: 'Enema', plural: 'Enemas' },
    // C124231: { singular: 'Inch Strip', plural: 'Inch Strips' },
    // C48538: { singular: 'Strip', plural: 'Strips' },
    // C48537: { singular: 'Spray', plural: 'Sprays' },
    // C48536: { singular: 'Scoopful', plural: 'Scoopfuls' },
    // C49668: { singular: 'Centimeter', plural: 'Centimeters' },
    // C48539: { singular: 'Suppository', plural: 'Suppositories' },
    // C48540: { singular: 'Syringe', plural: 'Syringes' },
    // C48501: { singular: 'Inhalation', plural: 'Inhalations' },
    // C53499: { singular: 'Film', plural: 'Films' },
    // C48500: { singular: 'Inch', plural: 'Inches' },
    // C62609: { singular: 'Ring', plural: 'Rings' },
    // C69124: { singular: 'Gum', plural: 'Gums' },
    // C28254: { singular: 'Milliliter', plural: 'Milliliters' },
    // C28253: { singular: 'Milligram', plural: 'Milligrams' },
    // C71324: { singular: 'Sachet', plural: 'Sachets' },
    // C71204: { singular: 'Nebule', plural: 'Nebules' },
    // C48580: { singular: 'Gallon', plural: 'Gallons' },
    // C62412: { singular: 'Applicator', plural: 'Applicators' },
    // C48505: { singular: 'Liter', plural: 'Liters' },
    // C48548: { singular: 'Troche', plural: 'Troches' },
    // C48506: { singular: 'Lozenge', plural: 'Lozenges' },
    // C48475: { singular: 'Bar', plural: 'Bars' },
    // C48552: { singular: 'Wafer', plural: 'Wafers' },
    // C53503: { singular: 'Stick', plural: 'Sticks' },
    // C48155: { singular: 'Gram', plural: 'Grams' },
    // C48551: { singular: 'Vial', plural: 'Vials' },
    // C53502: { singular: 'Sponge', plural: 'Sponges' },
    // C48473: { singular: 'Ampule', plural: 'Ampules' },
    // C48512: { singular: 'Milliequivalent', plural: 'Milliequivalents' },
    // C65032: { singular: 'Pad', plural: 'Pads' },
    // C48152: { singular: 'Microgram', plural: 'Micrograms' },
    // C111984: { singular: 'Pump', plural: 'Pumps' },
    // C53504: { singular: 'Swab', plural: 'Swabs' },
    // C122632: { singular: 'Injection', plural: 'Injections' },
    // C122631: { singular: 'Dropperful', plural: 'Dropperfuls' },
    // C122630: { singular: 'Auto-Injector', plural: 'Auto-Injectors' },
    // C102405: { singular: 'Capful', plural: 'Capfuls' },
    // C38046: { singular: 'Unspecified', plural: 'Unspecified' },
    // C44278: { singular: 'Unit', plural: 'Units' },
    // C122635: { singular: 'Pre-Filled Pen Syringe', plural: 'Pre-Filled Pen Syringes' },
    // C48519: { singular: 'Ounce', plural: 'Ounces' },
    // C122633: { singular: 'Lollipop', plural: 'Lollipops' },
    C48542: { singular: 'Tablet', plural: 'Tablets' },
    C122634: { singular: 'Pill', plural: 'Pills' },
    C48480: { singular: 'Capsule', plural: 'Capsules' }
};

export type PotencyCode = keyof typeof potencyCodeMap;

export const copayEligiblePotencyCodes = new Set(['C48480', 'C48542', 'C122634']);
